import { makeVar } from '@apollo/client';

import { authStorage } from 'utils/helpers/auth';

export const isOnlineVar = makeVar<boolean>(false);
export const isLoadingVar = makeVar<boolean>(false);
export const isLoggedInVar = makeVar<boolean>(!!authStorage.token);
